import React, { Component } from 'react';
import Header from './superAdminHeader';
import SchoolList from '../SchoolList/schoolList';
import Schools from '../Schools/';
/* import AddNewSchool from '../SchoolList/addNewSchool' */
import SchoolRec from '../Schools/schoolRec'
import LeadManagment from '../Schools/leadManagment'
import SupportManagment from '../Schools/supportManagment'
import DashBoard from '../Home/superAdminDashboard';
//import RegisterSchool from '../AddSchool/registerSchool'
import SchoolRegister from '../AddSchool/schoolRegister'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import SuperAdminAccount from '../Account/accountDetails';
import DataSync from '../../SchoolAdmin/DataSync/dataSync';
import CatererList from '../../SuperAdmin/caterer/catererList';
import CatererRecord from '../../SuperAdmin/caterer/catererRecord';
import DistrictList from '../../SuperAdmin/district/districtList';
import DistrictRecord from '../../SuperAdmin/district/districtRecord';
import Subscription from './../Subscription';
import SubscriptionRec from '../Subscription/subscriptionRec';
import BroadcastMessage from '../Support/broadcastMessage';
import StudentSearch from '../Schools/studentSearch';
import PendingTransactions from '../Support/broadcastMessage/PendingTransactions/pendingStripeTransactions';

let data = {};
let catererdata = {};
let districtdata = {};

class sadmin extends Component {
    constructor() {
        super();
        this.editSchool = this.editSchool.bind(this);

    }

    editSchool(school, action) {
        if (school !== '') {
            data = school
        } else {
            data = {};
        }
        data["actionType"] = action;
        //alert(JSON.stringify(data,null,2));
    }
    editCaterer(caterer, action) {
        if (caterer !== '') {
            catererdata = caterer
        } else {
            catererdata = {};
        }
        catererdata["actionType"] = action;
        //alert(JSON.stringify(data,null,2));
    }
    editCaterer(district, action) {
        if (district !== '') {
            districtdata = district
        } else {
            districtdata = {};
        }
        districtdata["actionType"] = action;
        //alert(JSON.stringify(data,null,2));
    }

    render() {
        return (
            <div>
                <Router>
                    <div style={{ overflowY: 'scroll', overflowX: 'hidden', height: 'calc(100vh - 70px)' }}>
                        <Header {...this} />
                        <Switch>
                            <Route exact={true} path="/superAdmin/accountDetails/:action?"
                                render={() => <SuperAdminAccount />} />
                            <Route exact={true} path="/superAdmin/schoolList"
                                render={() => <SchoolList editSchool={this.editSchool} />} />
                            <Route exact={true} path="/superAdmin/schools"
                                render={() => <Schools />} />
                            <Route exact={true} path="/superAdmin/leadManagment"
                                render={() => <LeadManagment />} />
                            <Route exact={true} path="/superAdmin/supportManagment"
                                render={() => <SupportManagment />} />
                            <Route exact={true} path="/superAdmin/broadcastMsg"
                                render={() => <BroadcastMessage />} />
                            <Route exact={true} path="/superAdmin/studentSearch"
                                render={() => <StudentSearch />} />
                            <Route exact={true} path="/superAdmin/schoolRecord/:id?"
                                render={(rest) => <SchoolRec {...rest} />} />
                            <Route exact={true} path="/superAdmin/regSchool/:id?"
                                render={() => <SchoolRegister school={data} />} />
                            <Route exact={true} path="/superAdmin/datasync"
                                render={() => <DataSync school={data} />} />
                            <Route exact={true} path="/superAdmin/catererList"
                                render={() => <CatererList editCaterer={this.editCaterer} />} />
                            <Route exact={true} path="/superAdmin/catererRecord/:cid?"
                                render={() => <CatererRecord />} />
                            <Route exact={true} path="/superAdmin/districtList"
                                render={() => <DistrictList editDistrict={this.editDistrict} />} />
                            <Route exact={true} path="/superAdmin/districtRecord/:did?"
                                render={() => <DistrictRecord />} />
                            <Route exact={true} path="/superAdmin/subscription"
                                render={() => <Subscription />} />
                            <Route exact={true} path="/superAdmin/subscription/:id"
                                render={() => <SubscriptionRec />} />
                            {/* <Route exact={true} path="/superAdmin/users"
                                render={() => <Users />} /> */}
                            <Route exact={true} path="/superAdmin/pending-transactions"
                                render={() => <PendingTransactions />} />
                            <Route render={() => <DashBoard editSchool={this.editSchool} editCaterer={this.editCaterer} editDistrict={this.editDistrict} />} />

                        </Switch>
                    </div>
                </Router>
            </div>
        );
    }

}

export default sadmin;


// WEBPACK FOOTER //
// ./src/components/SuperAdmin/Home/superAdminHome.jsx